'use client';
import { useEffect, useState } from 'react';
import { useT } from '../lib/i18n';
import { Icon } from './Icon';

/** 저장 키 — `layout` 의 첫 페인트 전 스크립트가 같은 키를 읽는다 */
export const THEME_KEY = 'theme';

/**
 * 라이트·다크 전환 — 가이드 `tgl-wrap`(마이페이지 좌측 메뉴 맨 아래, myclass.html).
 *
 * `html[data-theme]` 하나만 바꾼다 — 가이드 CSS 가 그 속성으로 팔레트를 갈아치우고
 * (`[data-theme=dark] .tgl` 처럼 토글 모양까지) 브랜드색도 `themeVars` 가 그 선택자로 낸다.
 * 그래서 버튼에 상태 클래스를 따로 붙이지 않는다.
 *
 * 고른 값은 브라우저에 남긴다 — 페이지를 옮길 때마다 라이트로 돌아가면 토글이 아니다.
 * 되살리는 것은 `<head>` 의 인라인 스크립트다(마운트 뒤에 바꾸면 흰 화면이 한 번 번쩍인다).
 * 여기서는 **읽기만 마운트 뒤에** 한다 — 서버 HTML 과 첫 렌더가 어긋나면 hydration 이 깨진다.
 */
export function ThemeToggle() {
  const t = useT();
  const [dark, setDark] = useState(false);
  useEffect(() => { setDark(document.documentElement.dataset.theme === 'dark'); }, []);

  const toggle = () => {
    const next = !dark;
    setDark(next);
    document.documentElement.dataset.theme = next ? 'dark' : 'light';
    try { localStorage.setItem(THEME_KEY, next ? 'dark' : 'light'); } catch { /* 저장 못 해도 전환은 된다 */ }
  };

  return (
    <div className="tgl-wrap">
      <span className="tgl-icon sun"><Icon name="sun" /></span>
      <button type="button" className="tgl" onClick={toggle} aria-pressed={dark} aria-label={t('my.theme')} />
      <span className="tgl-icon moon"><Icon name="moon" /></span>
    </div>
  );
}
